<template>
  <div class="whs-layout">
    <div class="whs-layout-row">
      <Breadcrumbs :location="$store.state.location" ref="breadcrumbs" />
    </div>
    <div class="whs-layout-row">
      <div class="whs-sidebar">
        <Hero ref="hero" />
        <RelativeHotels placement="aside"
          v-if="!isMobile && context !== 'office'" />
      </div>
      <div class="whs-content">
        <HotelDetail ref="detail" />
        <RelativeHotels placement="mid" />
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import { mapGetters } from 'vuex';
import HotelDetail from '@/components/HotelDetail.vue';
import RelativeHotels from '@/components/RelativeHotels.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Hotel',
  components: {
    Hero,
    HotelDetail,
    RelativeHotels,
    Breadcrumbs
  },
  computed: {
    ...mapGetters(['context']),
    isMobile() {
      return window.innerWidth < 1024;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('setLoading', vm.$store.state.hotel.wait.hotel);
      vm.$refs.detail.$el.scrollIntoView();

      const hasDirectionIds =
        vm.$store.state.hero.direction &&
        vm.$store.state.hero.direction.params.ids;

      // console.log(hasDirectionIds, vm.$store.state.hero);

      if (!vm.$store.state.hero.direction || hasDirectionIds) {
        new Promise(resolve => {
          if (hasDirectionIds) return resolve();
          vm.$store
            .dispatch('hero/setStateFromUri', vm.$route.query)
            .then(() => resolve());
        }).then(() => {
          // const hotelID = to.params.id
          //   ? to.params.id
          //   : Array.isArray(vm.$store.state.hero.direction.params.ids)
          //   ? vm.$store.state.hero.direction.params.ids[0]
          //   : vm.$store.state.hero.direction.params.ids;

          if (to.params.id) {
            // vm.$store.commit('setLoading', vm.$store.state.hotel.wait.hotel);
            vm.$store.commit('hotels/updateQuery', vm.$route.query);
            vm.$store.commit('hotels/updateHotels', {
              hotels: [{ id: to.params.id }]
            });
            vm.$store
              .dispatch('hotels/getHotelInfo', to.params.id)
              .then(() => vm.$store.dispatch('hotels/getHotelInfoDB'))
              .then(() => {
                vm.$store.dispatch(
                  'hotel/collect',
                  vm.$store.state.hotels.hotels.find(
                    hotel => hotel.id === to.params.id
                  )
                );
                vm.$store
                  .dispatch('hotels/getRegionCoords')
                  .then(() => vm.$store.dispatch('hotels/getRelativeHotels'))
                  .then(() => vm.$store.dispatch('hotels/getHotelInfo'));
              });
          }

          // vm.$store
          //   .dispatch('hotels/getHotels', vm.$route.query)
          //   .then(() => vm.$store.dispatch('hotels/getRelativeHotels'))
          //   .then(() => vm.$store.dispatch('hotels/getHotelInfo'));
          // vm.$store.commit('hotels/updateHotels', {
          //   hotels: [{ id: vm.$route.params.id }]
          // });
          // vm.$store
          //   .dispatch('hotels/getHotelInfo', vm.$route.params.id)
          //   .then(() => vm.$store.dispatch('hotels/getHotelInfoDB'))
          //   // .then(() => vm.$store.dispatch('getLocation', null, { root: true }))
          //   .then(() =>
          //     vm.$store.dispatch(
          //       'hotel/collect',
          //       vm.$store.state.hotels.hotels.find(
          //         hotel => hotel.id === vm.$route.params.id
          //       )
          //     )
          //   );
        });
      } else {
        const hotel = vm.$store.state.hotels.hotels.find(
          hotel => hotel.id === vm.$route.params.id
        );
        return vm.$store.dispatch('hotel/collect', hotel);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // console.log(this.$store.state.hero.direction.params.ids, to.params.id);
    // const hotelID = to.params.id
    //   ? to.params.id
    //   : Array.isArray(this.$store.state.hero.direction.params.ids)
    //   ? this.$store.state.hero.direction.params.ids[0]
    //   : this.$store.state.hero.direction.params.ids;

    if (to.params.id) {
      this.$store.commit('setLoading', this.$store.state.hotel.wait.hotel);
      this.$store.commit('hotels/updateQuery', to.query);
      this.$store.commit('hotels/updateHotels', {
        hotels: [{ id: to.params.id }]
      });
      this.$store
        .dispatch('hotels/getHotelInfo', to.params.id)
        .then(() => this.$store.dispatch('hotels/getHotelInfoDB'))
        .then(() => {
          this.$store.dispatch(
            'hotel/collect',
            this.$store.state.hotels.hotels.find(
              hotel => hotel.id === to.params.id
            )
          );
          this.$store
            .dispatch('hotels/getRegionCoords')
            .then(() => this.$store.dispatch('hotels/getRelativeHotels'))
            .then(() => this.$store.dispatch('hotels/getHotelInfo'));
        });
      this.$refs.breadcrumbs.$el.scrollIntoView();
    }
    next();
  }
};
</script>

<style scoped></style>